import { useAuth } from "@/auth/AuthProvider";
import { USER_ROLES } from "@/auth/userRoles";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useCustomers } from "@/customers/useCustomers";
import { useReviewableCountBySpecialty } from "@/admin-coding-dashboard/useReviewableCountBySpecialty";

const ALMOST_THROUGH_MAX_CASES = 49;

const QueueAlmostThroughPillContent = ({ customerIds }: { customerIds: string[] }) => {
  const { data } = useReviewableCountBySpecialty({ customerIds });
  const casesLeft = data?.total;

  if (!casesLeft || casesLeft > ALMOST_THROUGH_MAX_CASES) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="ml-2 inline-flex shrink-0 cursor-default items-center rounded-full border border-gray-300 bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700"
            tabIndex={0}
          >
            🏁 Almost through the queue
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>Only a few cases left. New cases are added regularly, so check back tomorrow.</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export const QueueAlmostThroughPill = () => {
  const { role } = useAuth();
  const { customers } = useCustomers();

  if (role !== USER_ROLES.clinical_coder || customers.length === 0) return null;

  return <QueueAlmostThroughPillContent customerIds={customers.map((c) => c.id)} />;
};
